"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useMediaQuery_1 = __importDefault(require("./useMediaQuery"));
var useOrientation = function () { return ((0, useMediaQuery_1.default)('(orientation: portrait)') ? 'portrait' : 'landscape'); };
exports.default = useOrientation;
